import { render, staticRenderFns } from "./ActivitiesList.vue?vue&type=template&id=3e2f2858&scoped=true&"
import script from "./ActivitiesList.vue?vue&type=script&lang=ts&"
export * from "./ActivitiesList.vue?vue&type=script&lang=ts&"
import style0 from "./ActivitiesList.vue?vue&type=style&index=0&id=3e2f2858&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2f2858",
  null
  
)

export default component.exports